// extracted by mini-css-extract-plugin
export var black = "_q-6";
export var brand = "_q-1";
export var ddefault = "_q-0";
export var error = "_q-3";
export var gray = "_q-2";
export var highContrast = "_q-8";
export var outline = "_q-7";
export var success = "_q-5";
export var warning = "_q-4";